export const mapIcons = {
    town: `<svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" viewBox="0 0 256 256">
              <path fill="#1F2648" d="M212.651 0H42.67C19.107 0 0 19.1 0 42.67v169.98c0 23.569 19.107 42.67 42.67 42.67h169.98c23.569 0 42.67-19.101 42.67-42.67V42.67C255.326 19.101 236.226 0 212.65 0z" />
              <rect x="47.097" y="59.908" width="161.806" height="135.54" fill="#fab313" rx="13" />
              <path fill="#1F2648" d="M100.57 162.48c-4.27 0-7.729-3.482-7.729-7.77v-54.1c0-4.287 3.458-7.769 7.729-7.769h54.18c4.283 0 7.73 3.482 7.73 7.77v54.1c0 4.287-3.447 7.768-7.73 7.768z" />
            </svg>`,

    sleep: `<svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" viewBox="0 0 24 24">
              <g stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                <path d="M17.8 13.938h-.011a7 7 0 1 0-11.464.144h-.016l.14.171q.15.19.3.371L12 21l5.13-6.248q.291-.314.54-.659z" fill="#1F2648" stroke="#8FA5BD"/>
                <path d="M12 13a3 3 0 1 0 0-6a3 3 0 0 0 0 6" fill="#1F2648" stroke="#8FA5BD"/>
              </g>
            </svg>`,
    partner: `<svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" viewBox="0 0 24 24">
                  <g stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                    <path d="M17.8 13.938h-.011a7 7 0 1 0-11.464.144h-.016l.14.171q.15.19.3.371L12 21l5.13-6.248q.291-.314.54-.659z" fill="#FAB313" stroke="#1F2648"/>
                    <path d="M12 13a3 3 0 1 0 0-6a3 3 0 0 0 0 6" fill="#FAB313" stroke="#1F2648"/>
                  </g>
                </svg>`
};